import {clientStaffRoutes} from '../utils';
import ExpensesTable from '@/views/expenses/ExpensesTable.vue';
import ExpensesCard from '@/views/expenses/ExpensesCard.vue';

export default [
   ...clientStaffRoutes({
      name: 'supplies-table',
      path: '/supplies/table',
      component: ExpensesTable,
      props: {expenseType: 'supplies'},
      stage: 'supplies',
      breadCrumb: [
         {text: 'Dashboard', to: {name: 'Home'}},
         {text: '__COMPANYNAME__', to: {name: 'company-detail', params: {id: 'FILL'}}},
         {text: 'Supplies - Declaration'},
      ],
   }),

   ...clientStaffRoutes({
      name: 'supplies-period-review',
      path: '/supplies/:periodId/company',
      component: ExpensesCard,
      props: {expenseType: 'supplies'},
      stage: 'supplies',
      breadCrumb: [
         {text: 'Dashboard', to: {name: 'Home'}},
         {text: '__COMPANYNAME__', to: {name: 'company-detail', params: {id: 'FILL'}}},
         {text: 'Supplies', to: {name: 'supplies-table-staff', params: {id: 'FILL'}}},
         {text: 'Supplies - Review'},
      ],
   }),
];
